"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrpcQueryClient = exports.GrpcWebError = void 0;
const grpc_web_1 = require("@improbable-eng/grpc-web");
class GrpcWebError extends Error {
    constructor(message, code, metadata) {
        super(message);
        this.code = code;
        this.metadata = metadata;
    }
}
exports.GrpcWebError = GrpcWebError;
/**
 * Uses grpc-web module on cosmos-sdk to simulate gRPC queries
 * throught HTTP/1.1.
 * see https://github.com/cosmos/cosmos-sdk/issues/7345
 */
class GrpcQueryClient {
    constructor(host, options = {}) {
        this.host = host;
        this.options = options;
    }
    request(serviceName, methodName, data) {
        return new Promise((resolve, reject) => {
            grpc_web_1.grpc.unary({
                methodName,
                service: { serviceName },
                requestStream: false,
                responseStream: false,
                requestType: {},
                responseType: {
                    deserializeBinary: (data) => data,
                },
            }, {
                request: Object.assign(Object.assign({}, data), { toObject: () => data, serializeBinary: () => data }),
                host: this.host,
                metadata: this.options.metadata,
                transport: this.options.transport,
                debug: false,
                onEnd: function (response) {
                    if (response.status === grpc_web_1.grpc.Code.OK) {
                        resolve(response.message);
                    }
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                },
            });
        });
    }
}
exports.GrpcQueryClient = GrpcQueryClient;
exports.default = GrpcQueryClient;
